/* eslint-disable react-refresh/only-export-components */
import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { getLiveHubCategories } from '@/lib/guides/categories'

const GuidesIndexPage = lazy(() => import('@/pages/guides/GuidesIndexPage').then((m) => ({ default: m.GuidesIndexPage })))
const GuidesCategoryHubPage = lazy(() =>
  import('@/pages/guides/GuidesCategoryHubPage').then((m) => ({ default: m.GuidesCategoryHubPage })),
)
const GuideArticlePage = lazy(() => import('@/pages/guides/GuideArticlePage').then((m) => ({ default: m.GuideArticlePage })))

export function guidesRoutes() {
  return (
    <>
      <Route path="/guides" element={<GuidesIndexPage />} />
      {/* Static category-hub routes for promoted categories MUST precede
          the dynamic /guides/:slug so an article slug is never shadowed
          (SEO §5 step 6). getLiveHubCategories() is the registry guard:
          only promoted + HUB_ROUTES_LIVE slugs get a hub route. */}
      {getLiveHubCategories().map((category) => (
        <Route
          key={category.slug}
          path={`/guides/${category.slug}`}
          element={<GuidesCategoryHubPage categorySlug={category.slug} />}
        />
      ))}
      <Route path="/guides/:slug" element={<GuideArticlePage />} />
    </>
  )
}
